import { render, staticRenderFns } from "./AdminSurfChange.vue?vue&type=template&id=194fc93e&scoped=true"
import script from "./AdminSurfChange.vue?vue&type=script&lang=js"
export * from "./AdminSurfChange.vue?vue&type=script&lang=js"
import style0 from "./AdminSurfChange.vue?vue&type=style&index=0&id=194fc93e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194fc93e",
  null
  
)

export default component.exports